module.exports = __webpack_public_path__ + "img/lawjudge2.1b496194.png";